<template>
  <div class="wrapper">
    <div class="slide-wrapper">
      <ul>
        <li v-for="(item,index) in titleList" :key="index">
          <div
            class="first-title"
            :class="{'first-title-active':item.year ==firstFlag}"
            @click="changeFlag(item.year)"
          >
            第{{item.year}}年期刊
            <span class="circle"></span>
          </div>
          <div class="second-wrapper" v-if="item.year == firstFlag">
            <div class="second-inner">
              <div
                v-for="(childItem) in item.nums"
                :key="childItem.journal_id"
                class="second-title"
                :class="{'second-title-active':childItem.journal_id ==secondFlag}"
                @click="changeSecondFlag(childItem.journal_id,childItem.num)"
              >
                <div class="second-title-style">
                  第{{childItem.num}}期 期刊
                  <span class="second-circle"></span>
                </div>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<style scoped>
.slide-wrapper {
  width: 310px;
  background: #e6ecf2;
  border-radius: 10px;
  padding: 20px 0;
  box-sizing: border-box;
  border: 1px solid #e6ecf2;
}
.first-title {
  width: 310px;
  height: 60px;
  line-height: 20px;
  /* display: table-cell;
  vertical-align: middle; */
  display: flex;
  justify-content: center;
  flex-direction: column;
  border-bottom: 1px solid #cdd7e2;
  color: #1e4cb0;
  font-size: 18px;
  padding-left: 40px;
  padding-right: 40px;
  box-sizing: border-box;
  position: relative;
  cursor: pointer;
  background: #f7f7f7;
}
.first-title .circle {
  position: absolute;
  top: 50%;
  left: 16px;
  width: 15px;
  height: 15px;
  transform: translateY(-50%);
  background: #fff;
  border: 3px solid #1e4cb0;
  border-radius: 50%;
  box-sizing: border-box;
}
.first-title-active .circle {
  background: #1e4cb0;
  border: 3px solid #ffffff;
}
.first-title-active::after {
  position: absolute;
  content: "";
  top: 0;
  right: 10px;
}
.first-title::before {
  position: absolute;
  content: "";
  top: 0;
  right: 20px;
  width: 20px;
  height: 100%;
  background: url(/static/img/title-down-icon.png) no-repeat center center;
  background-size: 14px 10px;
}
.first-title-active::before {
  background: url(/static/img/title-up-icon.png) no-repeat center center !important;
  background-size: 14px 10px;
}
.first-title-active {
  background: url(/static/img/common-nav.png) no-repeat center center;
  background-size: 100% 60px;
  color: #fff;
}
.second-wrapper {
  overflow: hidden;
  transition: height 0.5s ease-in-out;
}
.second-title-active {
  background: #256ec8 !important;
  color: #fff;
}
.second-title .second-circle {
  position: absolute;
  top: 50%;
  left: 19px;
  width: 8px;
  height: 8px;
  transform: translateY(-50%);
  background: #dfdfdf;
  border-radius: 50%;
  box-sizing: border-box;
}
.second-title-active .second-circle {
  background: #fff;
}
.second-title {
  width: 100%;
  height: 60px;
  background: #fff;
  display: table;
  position: relative;
  padding-left: 40px;
  box-sizing: border-box;
  font-size: 16px;
  cursor: pointer;
}
.second-title-style {
  display: table-cell;
  vertical-align: middle;
  line-height: 20px;
  border-bottom: 1px solid #e6ecf2;
  padding-left: 4px;
  box-sizing: border-box;
}
.second-inner .second-title:last-child .second-title-style{
   border-bottom:none;
}
.second-title-active .second-title-style {
  border-bottom: none;
}
</style>

<script>
import { userApi } from "@/api/user.js";
export default {
  data() {
    return {
      firstFlag: this.$route.query.year,
      secondFlag: this.$route.query.id,
      hei: 0,
      titleList: [],
      nowYear: new Date().getFullYear(),
      nowMonth: new Date().getMonth()
    };
  },
  methods: {
    // getSlideList() {
    //   var showYear = 8; //看展示近八年的
    //   var showMonth = 12;
    //   var nowDate = new Date();
    //   nowDate.setYear(nowDate.getFullYear() + 1);
    //   var result = [];
    //   for (var i = 0; i < showYear; i++) {
    //     nowDate.setYear(nowDate.getFullYear() - 1);
    //     result[i] = {
    //       title: nowDate.getFullYear() + "年期刊",
    //       value: nowDate.getFullYear(),
    //       children: []
    //     };
    //     if (nowDate.getFullYear() == this.nowYear) {
    //       showMonth = this.nowMonth; //判断当前的年月分 若为当前年  则显示  当前月份之前的list
    //     } else {
    //       showMonth = 12;
    //     }
    //     for (var j = 1; j <= showMonth; j++) {
    //       result[i].children.push({
    //         title: "第" + j.toString().padStart(2, 0) + "期 期刊",
    //         value: j.toString().padStart(2, 0)
    //       });
    //     }
    //   }
    //   this.titleList = result;
    //   // console.log(this.titleList);
    // },
    getSlideList() {
      userApi.getjournalperiod().then(res => {
        this.titleList = res.data;
      });
    },
    changeFlag(index) {
      this.firstFlag = index;
    },
    changeSecondFlag(id, num) {
      this.secondFlag = id;
      this.$router.push({
        name: "JournalDetail",
        query: { id: id, year: this.firstFlag, num: num }
      });
    },
    toPage(url) {
      this.$router.push(url);
    }
  },
  mounted() {
    this.getSlideList();
    setTimeout(() => {
      this.changeFlag(this.$route.query.year);
    }, 100);
  }
};
</script>




// WEBPACK FOOTER //
// src/components/views/Journal/slide.vue